import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";
import HomePage from "./pages/HomePage";
import EAPage from "./pages/EAPage";
import InsideBarPage from "./pages/InsideBarPage";
import OrbAlgoPage from "./pages/OrbAlgoPage";
import AdminPage from "./pages/AdminPage";
import AdminCallsPage from "./pages/AdminCallsPage";
import AdminCRMPage from "./pages/AdminCRMPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import RefundPolicy from "./pages/RefundPolicy";
import RiskDisclosure from "./pages/RiskDisclosure";
import ContactUs from "./pages/ContactUs";
import SupportPage from "./pages/SupportPage";
import StrategyLabPage from "./pages/StrategyLabPage";
import StrategyDetailPage from "./pages/StrategyDetailPage";
import AdminLabPage from "./pages/AdminLabPage";

function App() {
  return (
    <div className="App bg-black min-h-screen">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/ea" element={<EAPage />} />
          <Route path="/inside-bar" element={<InsideBarPage />} />
          <Route path="/orb-algo" element={<OrbAlgoPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/strategy-lab" element={<StrategyLabPage />} />
          <Route path="/strategy-lab/:slug" element={<StrategyDetailPage />} />
          <Route path="/admin/lab" element={<AdminLabPage />} />
          <Route path="/admin/calls" element={<AdminCallsPage />} />
          <Route path="/admin/crm" element={<AdminCRMPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/risk-disclosure" element={<RiskDisclosure />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/support" element={<SupportPage />} />
        </Routes>
        <Footer />
        <WhatsAppButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
